import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const streamChat = async (conversationId, content, onToken, onDone, onError, attachmentIds = []) => {
  try {
    const response = await fetch(`${API}/conversations/${conversationId}/messages`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ content, attachment_ids: attachmentIds }),
    });
    if (!response.ok || !response.body) {
      onError("Connection to AVA core failed.");
      return;
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n\n");
      buffer = lines.pop();
      for (const line of lines) {
        if (!line.startsWith("data: ")) continue;
        const jsonStr = line.slice(6);
        try {
          const data = JSON.parse(jsonStr);
          if (data.token) onToken(data.token);
          if (data.error) onError(data.error);
          if (data.done) onDone(data.sources || [], data.message_id);
        } catch (e) {
          // ignore malformed chunk
        }
      }
    }
  } catch (e) {
    onError(e.message || "Stream interrupted.");
  }
};
